import { Job, JobApplication } from '@core/generated/gql-types';
import AppliedWorkers from './AppliedWorkers';
import AssignJobWorkers from './AssignJobWorkers';
import {
  TemplateTerm,
  useTemplateStore,
} from '@core/template/useTemplateStore';

interface SelectWorkerOptionsProps {
  job: Job;
  jobApplications: JobApplication[];
  loading: boolean;
  setLoading: (loading: boolean) => void;
  openWorkerSearchModal: boolean;
  setOpenWorkerSearchModal: (open: boolean) => void;
  showAllApplicants: boolean;
}

const SelectWorkerOptions = ({
  job,
  jobApplications,
  loading,
  setLoading,
  openWorkerSearchModal,
  setOpenWorkerSearchModal,
  showAllApplicants = true,
}: SelectWorkerOptionsProps) => {
  const { getTerm } = useTemplateStore();

  if (loading) {
    return (
      <div className="flex h-14 w-full items-center justify-between gap-2 rounded-md bg-white p-2">
        <div className="flex items-center gap-2">
          <div className="pl-3 text-sm text-gray-600">Loading...</div>
        </div>
      </div>
    );
  }

  // Render the apply type job workers.
  if (job.workersShouldApplyToJob && jobApplications.length > 0) {
    return (
      <AppliedWorkers
        job={job}
        jobApplications={jobApplications}
        setLoading={setLoading}
        openWorkerSearchModal={openWorkerSearchModal}
        setOpenWorkerSearchModal={setOpenWorkerSearchModal}
      />
    );
  }

  if (!showAllApplicants) {
    return (
      <div className="flex h-12 w-full items-center justify-between gap-2 rounded-md bg-white p-2">
        <div className="flex items-center gap-2">
          <div className="pl-3 text-sm text-gray-600">
            No {getTerm(TemplateTerm.WORKER, false)} assigned
          </div>
        </div>
      </div>
    );
  }

  // Otherwise render the assign functionality for apply type jobs
  // without any applied workers, or assign type jobs.
  return (
    <AssignJobWorkers
      job={job}
      setLoading={setLoading}
      openWorkerSearchModal={openWorkerSearchModal}
      setOpenWorkerSearchModal={setOpenWorkerSearchModal}
    />
  );
};

export default SelectWorkerOptions;
